import Cookies from 'js-cookie';

const mgr = (window as any).mgr;

const TokenKey = mgr._userStore._prefix + mgr._userStoreKey;


export const getToken = () => {
  console.log(TokenKey);
  const token = window.localStorage.getItem(TokenKey);
  if (token == null) {
    // window.localStorage.setItem('ESResourceadmin_RedirectURL', window.location.href);
    // window.mgr.signinRedirect();
    // console.log('redirect')
    return false;
  }
  // console.log(token)
  return JSON.parse(token);
};

export const getAccessToken = () => {
  const token = getToken();
  if (token) {
    // console.log(token.access_token)
    return token.access_token;
  }
  return false;
};
export const setToken = (token: string) => Cookies.set(TokenKey, token);

export  const getIdToken = () => {
  // const token = getToken();
  // if (token) {
  //   return token.id_token;
  // }
  // return false;
  // return (window as any).mgr.getUser()
}

export const removeToken = () => window.localStorage.removeItem(TokenKey);
